import PropTypes from 'prop-types'

import ChangeBankAccountPrompt from './ChangeBankAccountPrompt'
import StatementNotification from './StatementNotification'

const Alert = ({
  outsidePayments,
  payInvoice,
  supplierName,
  payerName,
  onOpenBankAccountDetails,
}) => {
  if (!outsidePayments) {
    return null
  }

  if (payInvoice) {
    return (
      <ChangeBankAccountPrompt
        supplierName={supplierName}
        onOpenBankAccountDetails={onOpenBankAccountDetails}
      />
    )
  }

  return <StatementNotification payerName={payerName} />
}

Alert.propTypes = {
  outsidePayments: PropTypes.bool.isRequired,
  payInvoice: PropTypes.bool.isRequired,
  supplierName: PropTypes.string.isRequired,
  payerName: PropTypes.string.isRequired,
  onOpenBankAccountDetails: PropTypes.func.isRequired,
}

export default Alert
